module.exports = __webpack_public_path__ + "static/media/sade_logo.0c6bca24.png";